/**
 * Constantes da página de Recebíveis (Contas a Receber).
 */

import { FINANCIAL_STATUS, FINANCIAL_STATUS_LABELS, FINANCIAL_STATUS_COLORS, FINANCIAL_SOURCES, FINANCIAL_SOURCE_LABELS, FINANCIAL_PAYMENT_METHOD_LABELS } from '../../../constants/financial';

export const RECEIVABLE_STATUS = {
    PENDING: { id: FINANCIAL_STATUS.PENDING, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.PENDING], color: FINANCIAL_STATUS_COLORS[FINANCIAL_STATUS.PENDING] },
    PAID: { id: FINANCIAL_STATUS.PAID, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.PAID], color: FINANCIAL_STATUS_COLORS[FINANCIAL_STATUS.PAID] },
    OVERDUE: { id: FINANCIAL_STATUS.OVERDUE, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.OVERDUE], color: FINANCIAL_STATUS_COLORS[FINANCIAL_STATUS.OVERDUE] },
    CANCELED: { id: FINANCIAL_STATUS.CANCELED, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.CANCELED], color: FINANCIAL_STATUS_COLORS[FINANCIAL_STATUS.CANCELED] },
};

export const RECEIVABLE_STATUS_OPTIONS = [
    { value: "", label: "Todos os status" },
    { value: FINANCIAL_STATUS.PENDING, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.PENDING] },
    { value: FINANCIAL_STATUS.PAID, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.PAID] },
    { value: FINANCIAL_STATUS.OVERDUE, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.OVERDUE] },
    { value: FINANCIAL_STATUS.CANCELED, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.CANCELED] },
];

export const PAYMENT_METHOD_LABELS = FINANCIAL_PAYMENT_METHOD_LABELS;

export const SOURCE_TYPE_LABELS = {
    [FINANCIAL_SOURCES.MEMBER]: FINANCIAL_SOURCE_LABELS[FINANCIAL_SOURCES.MEMBER],
    [FINANCIAL_SOURCES.ACQUIRER]: FINANCIAL_SOURCE_LABELS[FINANCIAL_SOURCES.ACQUIRER],
};

export const PAGE_SIZE = 25;
